import { ContentProps } from "./types";
import { ContentView } from "./view";

export const Content = (props: ContentProps) => {
	return <ContentView content={props.module.content} />;
};
